import styled from 'styled-components';
import * as tokens from '@ftdata/tokens';

export const DefaultIconContainer = styled.div`
    width: 1rem;
    height: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 800;
    cursor: pointer;
    z-index: 10;
    svg {
        color: ${tokens.COLOR_NEUTRAL_DARKER};
    }

    &:hover svg {
        color: ${tokens.COLOR_NEUTRAL_DARK};
        stroke: ${tokens.COLOR_NEUTRAL_DARK};
    }
`;
